import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, UseFormProps } from 'react-hook-form'
import { z } from 'zod'

import { makeGenericZodErrorMessage } from '@/utils/make-generic-zod-error-message'

const temperature_schema = z
  .number(makeGenericZodErrorMessage('A temperatura é obrigatória!'))
  .int({ message: 'Deve ser um número inteiro!' })
  .min(-10, { message: 'O número deve ser maior ou igual a -10!' })
  .max(400, { message: 'O número deve ser menor ou igual a 400!' })

const schema = z.object({
  phenological_stage: z
    .string(makeGenericZodErrorMessage('O estádio fenológico é obrigatório!'))
    .min(1, 'O estádio fenológico é obrigatório!'),
  color_scale: z
    .string(makeGenericZodErrorMessage('A escala de cor é obrigatória!'))
    .min(1, 'A escala de cor é obrigatória!'),
  min_temperature: temperature_schema,
  max_temperature: temperature_schema,
  space_between_lines: z.coerce
    .number()
    .min(20, { message: 'O número deve ser maior ou igual a 20!' })
    .max(60, { message: 'O número deve ser menor ou igual a 60!' })
    .or(z.literal('').transform(() => undefined)),
  space_between_plants: z.coerce
    .number()
    .min(3, { message: 'O número deve ser maior ou igual a 3!' })
    .max(25, { message: 'O número deve ser menor ou igual a 25!' })
    .or(z.literal('').transform(() => undefined)),
})

export type DefaultPhysiologicalRegisterForm = z.infer<typeof schema>

export const usePhysiologicalRegisterForm = (
  props?: UseFormProps<DefaultPhysiologicalRegisterForm>,
) => {
  const methods = useForm<DefaultPhysiologicalRegisterForm>({
    resolver: zodResolver(schema),
    ...props,
  })

  return methods
}
